import { all } from 'redux-saga/effects';

import appMarketSaga from './appMarket';
import myAppSaga from './myApp';
import appLearnMoreSaga from './appLearnMore';
import partnerConsentSaga from './partnerConsent';

export default function* employeesSaga() {
  yield all([
    appMarketSaga(),
    myAppSaga(),
    appLearnMoreSaga(),
    partnerConsentSaga(),
  ]);
}
